<template>
    <div>
        <div class="text-center">
            <h2>Panagiotis Kalozoumis</h2>
        </div>
        <v-container class="main-text text-container">
            <div>
                <v-img :width="415" :height="415" style="float: left;" class="bradius" :src="require('@/assets/partners/Photo-P-Kalozoumis.jpg')" />
                <p class="cv-text">
                    Dr. Panagiotis Kalozoumis was born in Athens, Greece in 1994. He was awarded an Integrated Master Diploma in Agriculture from the Agricultural University of Athens (AUA) in 2017. In 2023 he completed his PhD in the Laboratory of Vegetable Production (AUA) under the supervision of Professor Dimitrios Savvas. He is currently working as a post-doc researcher on two European projects, ECONUTRI (HORIZON) and InPlasTwin. Other project involvements include the European research projects TOMRES (HORIZON) and OPTIMUS. His bachelor thesis was about cultivating vegetables in green roofs, a study conducted in collaboration between the Laboratory of Vegetable Production and the Laboratory of Floriculture &amp; Landscape Architecture of AUA. His research work includes 5 peer-reviewed scientific papers and 4 peer-reviewed national and international conference proceedings.
                </p>
                <p class="cv-text">
                    He is concomitantly running his own business which focuses on advisory services on open field and greenhouse crops, Landscape design and construction and Pest Control services. His research interests include greenhouse and open-field vegetable production, soilless cultivation systems, organic production, urban farming etc.
                </p>
                <p class="cv-text">
                    In 2024 he was also the Symposium Secretary of the "I Int. Symposium on Protected Cultivation, Nettings and Screens for Mild Climates" in Athens, whereas in 2026 he was appointed as a convener for the "III International Symposium on Growing Media, Compost Utilization and Substrate Analysis for Soilless Cultivation" which will also be held in Athens, Greece in September 2027 alongside with his professor Dimitrios Savvas.
                </p>
                <p class="cv-text contact-info">
                    <strong>Contact info:</strong><br/>
                    e-mail: <a href="mailto:kalozoumis@aua.gr">kalozoumis@aua.gr</a><br/>
                    telephone: 0030 6982863724<br/>
                    LinkedIn: <a href="https://www.linkedin.com/in/panagiotis-kalozoumis-443ba9289/" target="_blank">https://www.linkedin.com/in/panagiotis-kalozoumis-443ba9289/</a>
                </p>
            </div>
        </v-container>
    </div>
</template>

<script>
    export default {
        name: 'App',
        components: {
        },
        data: () => ({
        }),
        computed: {
        }
    }
</script>
<style scoped>
.cv-card {
    border: 1px solid #D9D9D9;
    border-radius: 25px;
    text-align: center;
}
.bradius {
    border-radius: 25px;
    margin-right: 15px;
}
.cv-text {
    display: inline;
}
.main-text {
    width: 90%;
    max-width: 900px;
    margin: auto;
    color: #646464;
}
.contact-info {
    display: block;
    margin-top: 15px;
}

@media (max-width: 600px) {
    .bradius {
        float: none !important;
        display: block;
        margin: 0 auto 15px !important;
        max-width: 280px;
    }
}
</style>
